import {nomeMeses} from "@/helpers";

const opcoes = {
  chart: {
    type: "bar",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    }
  },
  plotOptions: {
    bar: {
      endingShape: "rounded",
      dataLabels: {
        position: "top",
        orientation: "vertical"
      }
    }
  },
  grid: {
    show: true,
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    style: {
      fontSize: "14px"
    }
  },
  labels: [0,0,0,0,0,0,0,0,0,0,0,0,0],
  legend: {
    show: true,
    offsetY: 5,
    position: "top",
    markers: {
      width: 13,
      height: 13,
      radius: 2
    }
  },
  dataLabels: {
    enabled: true,
    offsetY: 4,
    style: {
      fontSize: "11px",
      fontWeight: 0,
      colors: ["#000"]
    },
    formatter: function(val) {
      return formatter(val) || "";
    }
  },
  stroke: {
    show: true,
    offsetY: -15,
    width: 2,
    colors: ["transparent"]
  },
  xaxis: {
    labels: {
      minWidth: 50,
      maxWidth: 50,
      formatter: referencia => {
        if (!`${referencia}`.includes('/')) return 'Mês';

        const [mes] = `${referencia}`.split('/');
        return (nomeMeses[parseInt(mes) - 1] || ' ').substring(0, 3);
      }
    }
  },
  yaxis: {
    title: {
      text: "Análise de Compras vs Vendas",
      style: {
        color: "#000",
        fontSize: "12px",
        fontWeight: 600,
        cssClass: "apexcharts-yaxis-title"
      }
    },
    labels: {
      formatter: function(val) {
        if(val === Infinity) return 1;
        return formatter(val, 0);
      }
    },
  },
  tooltip: {
    enabled: true,
    x: {
      show: true,
      formatter: valor => {
        if (typeof valor != "string") return valor;

        const dt = valor.split("/");
        return `${meses[parseInt(dt[0]) - 1] || dt[0]} de ${dt[1]}`;
      }
    },
    y: {
      show: true,
      format: "dd MMM",
      formatter: valor => {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL"
        }).format(valor);
      }
    }
  }
};

const meses = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

function formatter(n) {
  var ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" }
  ];

  for (var i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      return (
        (Math.round(n) / ranges[i].divider).toFixed(2).toString() +
        ranges[i].suffix
      );
    }
  }

  return n;
}

export { opcoes };
